

<template>

                <CreateCampaign v-if="editCampaignFlag" :isNewCampaign="this.isNewCampaign"
                    :adGroupsListData="this.adGroupsListData" :campaignData="this.campaignData"
                    :sellerIdRole="this.sellerIdRole" @backClicked="onCloseCampaignNavigation"
                    :editCampaign="this.editCampaign" />

                <div v-if="!editCampaignFlag" class="heading">Campaigns</div>
                <div v-if="apiErrorMessage" class="errorContainer">
                    <div class="errorHeading">Backend Error</div>
                    <div class="apiErrorMessage">{{ apiErrorMessage }}</div>
                </div>
                <div v-if="!editCampaignFlag" class="campaignsContainer">
                    <div class="campaigns" @click="onCampiagnsClick">

                        <div class="campaignLandingPage">
                            <div class="createCampaign">
                                <div class="lhs">
                                    <div class="searchClass">
                                        <input v-model="search" type="text" placeholder="Search by name" class="search">

                                    </div>
                                    <div class="dateRangeWrapper">
                                        <div @click="onDateRangeClick" class="dateRange">{{ dateFilterType }}
                                            <img class="arrowIcon" src="../assets/arrowIcon.svg" />
                                        </div>
                                        <div class="dateRangeContainer" v-if="showDateRangeFilter">
                                            <div class="dateText" @click="onDateRangeApply('CUSTOM')">Custom</div>
                                            <div v-if="showCustomDate" class="applyClass">
                                                <input class="dateFilter" type="date"
                                                    style="margin-right: 12px; cursor: pointer;" :max="disableFutureDate"
                                                    v-model="startDate">
                                                <input class="dateFilter" type="date"
                                                    style="margin-right: 12px; cursor: pointer;" :min="startDate"
                                                    :max="disableFutureDate" v-model="endDate">
                                                <div v-if="this.startDate && this.endDate" class="applyBtn"
                                                    @click="onDateRangeApply"> Apply </div>
                                            </div>
                                            <div class="dateText" @click="onDateRangeApply('TODAY')">Today</div>
                                            <div class="dateText" @click="onDateRangeApply('LAST_1D')">Last 1 day</div>
                                            <div class="dateText" @click="onDateRangeApply('LAST_7D')">Last 1 week</div>
                                            <div class="dateText" @click="onDateRangeApply('LAST_30D')">Last 1 month</div>
                                            <div class="dateText" @click="onDateRangeApply('CURRENT_MONTH')">Current month
                                            </div>
                                        </div>
                                    </div>
                                    <a target="_blank" class="dateRange"
                                        @click="onDownloadTableClick(this.startDate, this.endDate)">Download Table
                                        <img class="downloadIcon" src="../assets/downloadIcon.svg" />
                                    </a>
                                </div>
                                <div @click="onCreateCampaignClick"
                                    v-bind:class="enableCreateCampaign || (role === 'SUPERADMIN' || role === 'OPS') ? 'createBtn' : 'disabledCreateBtn'" v-b-tooltip
                                    :title="tooltipTitle" class="createBtn">
                                    Create New Campaign
                                </div>

                            </div>
                            <table>
                                <thead>
                                    <tr class="headerRow">
                                        <th class="header">Status</th>
                                        <th class="header">Name</th>
                                        <th class="header">Campaign ID</th>
                                        <th class="header">Campaign Class</th>
                                        <th class="header">Created by</th>
                                        <th class="header">Start Date<img alt="img" style="cursor: pointer"
                                                @click="onSortClick('startDateTime')" src="../assets/Vector.svg" /></th>
                                        <th class="header">End Date<img alt="img" style="cursor: pointer"
                                                @click="onSortClick('endDateTime')" src="../assets/Vector.svg" /></th>
                                        <th class="header">Budget<img alt="img" style="cursor: pointer"
                                                @click="onSortClick('budget')" src="../assets/Vector.svg" /></th>
                                        <th class="header">Spend<img alt="img" style="cursor: pointer"
                                                @click="onSortClick('spend')" src="../assets/Vector.svg" /></th>
                                        <th class="header">Clicks</th>
                                        <th class="header">Orders</th>
                                        <th class="header">Sales</th>
                                        <th class="header">ROAS</th>
                                        <th class="header">Actions</th>
                                    </tr>
                                </thead>
                                <tbody v-if="resultQuery?.length > 0">
                                    <tr v-for="item, index in resultQuery" :key="index" class="rowItem">
                                        <td v-if="item.state" class="statusWrapper">
                                            <div v-if="item.state == 0" class=" saved status">{{ formatStatus(item.state) }}
                                            </div>
                                            <div v-else class=" active status">{{ formatStatus(item.state) }}</div>
                                        </td>
                                        <td v-else class="statusWrapper">
                                            <div class="saved status"> NULL</div>
                                        </td>
                                        <td class="item name" @click="navigateToCampaignScreen(item, 'edit')" v-b-tooltip
                                            :title="decodeString(item.name)">{{ decodeString(item.name) }}</td>
                                        <td class="item">{{ item.id }}</td>
                                        <td class="item">{{item.campaignClass}}</td>
                                        <td class="item">{{ item.campaignCreatedBy ?? '' }}</td>
                                        <td class="item">{{ formatDate(item.start_time) }}</td>
                                        <td class="item">{{ item.expire_time != null ? formatDate(item.expire_time) :
                                            "Lifetime" }}</td>
                                        <td class="item">₹ {{ item?.budget === null || item.campaignClass === 'Privileged' ? 0 : item?.budget }}</td>
                                        <td class="item">₹ {{ item.homePageMetrics?.length > 0 ?
                                            item.homePageMetrics[0]?.spend != null ? item.homePageMetrics[0].spend : 0 : 0
                                        }} </td>
                                        <td class="item">{{ item.homePageMetrics?.length > 0 ?
                                            item.homePageMetrics[0]?.clicks != null ? item.homePageMetrics[0].clicks : 0 :
                                            0 }}</td>
                                        <td class="item">{{ item.homePageMetrics?.length > 0 ?
                                            item.homePageMetrics[0]?.orders != null ? item.homePageMetrics[0].orders : 0 :
                                            0 }}</td>
                                        <td class="item">{{ item.homePageMetrics?.length > 0 ?
                                            item.homePageMetrics[0]?.sales != null ? item.homePageMetrics[0].sales : 0 : 0
                                        }}</td>
                                        <td class="item">{{ item.homePageMetrics?.length > 0 ? item.homePageMetrics[0]?.roas
                                            != null ? item.homePageMetrics[0].roas === 0 ? 0 :
                                            item.homePageMetrics[0].roas.toFixed(2) : 0 : 0 }}</td>
                                        <td class="item">
                                            <!-- <img alt="img" class="copyIcon" @click="onCloneCampaignClick(item)"  src="../assets/copyIcon.svg" /> -->
                                            <img alt="img" v-if="item.state === 2 && item.status === 0 && (item.campaignClass !== 'Privileged' || (role !== 'BRAND' && role !== 'SELLER'))" class="copyIcon"
                                                @click="onClick(item, 'play')" src="../assets/playIcon.svg" />
                                            <img alt="img" v-else-if="(item.state === 1 && item.status === 1) && (item.campaignClass !== 'Privileged' || (role !== 'BRAND' && role !== 'SELLER'))" class="copyIcon"
                                                @click="onClick(item, 'pause')" src="../assets/pauseIcon.svg" />
                                            <img alt="img" v-else class="copyIcon" src="../assets/pauseIconDisable.svg" />
                                        </td>
                                    </tr>
                                </tbody>

                            </table>
                            <div class="emptyList"
                                v-if="(resultQuery?.length === 0 || this.campaigns?.length === 0 || resultQuery === undefined)">
                                <img alt="img" style="width: 174px; height: 174px" src="../assets/emptyList.png" />
                                <div class="emptyCaseTitle">No return window added. You can either bulk upload or select and
                                    add categories.</div>
                            </div>
                            <div class="paginate">
                                <div class="rows">
                                    <span class="pageinationText">Page {{ currentPage }} of {{ isNaN(totalPages) ? 1 :
                                        totalPages }}</span>
                                    <div class="flexClass">
                                        <p class="pageinationText">Rows per page</p>
                                        <select class="limit" v-model="rowsPerPage" @change="onRowsPerPageChanged">
                                            <option v-for="option in options" v-bind:key="option" :value="option">{{ option }}
                                            </option>
                                        </select>
                                        <img alt="img" v-if="currentPage > 1" @click="prevPage" class="leftArrow"
                                            src="../assets/leftArrow.svg" />
                                        <img alt="img" v-else class="leftArrowDisabled" src="../assets/leftArrow.svg" />
                                        <img alt="img" v-if="currentPage < totalPages" @click="nextPage" class="rightArrow"
                                            src="../assets/rightArrow.svg" />
                                        <img alt="img" v-else class="leftArrowDisabled" src="../assets/rightArrow.svg" />
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
                <CampaignClassDialog
                    v-if="showCampaignTypeDialog"
                    :enableCreateCampaign="enableCreateCampaign"
                    @cancelClicked="onCloseCampaignClass"
                    @continueClicked="onContinueClick"
                />
</template>

<script>

import CreateCampaign from "../components/CreateCampaign.vue"
import { toRaw, ref } from 'vue';
import Header from './Header.vue'
import LeftMenu from './LeftMenu.vue'
import {
    getCampaignList,
    getCampaign,
    deleteCampaign,
    createCampaign,
    getQueryParam,
    downloadCampaignHomePageMetrics,
    getAdgroupsList,
    adgroupView,
    getCookie,
    checkAvailableCredit,
    modifyCampaign,
    getLoggedSellerId,
    clearCookie
} from '../services/campaignService';
import { STATES } from '../constants';
import { APP_SITE_ID, ADSPOTS, ADSPOTS_PDP } from '../env';
import { mapActions, mapState } from 'vuex';
import moment from 'moment';
import ConfirmationModal from './ConfirmationModal.vue'
import AnalyticsLandingPage from './AnalyticsLandingPage.vue'
import Billing from "./Billing.vue";
import CampaignClassDialog from './CampaignClassDialog';

let page = ref(1);

export default {
    name: 'Campaigns',
    components: {
        ConfirmationModal,
        CreateCampaign,
        AnalyticsLandingPage,
        Header,
        LeftMenu,
        Billing,
        CampaignClassDialog
    },
    props: {
        msg: String
    },


    data() {
        return {
            warnMessage: 'you want to delete this campaign',
            showConfirmationModal: false,
            filterChanged: false,
            showStatusFilter: false,
            showDateRangeFilter: false,
            editCampaignFlag: false,
            editCampaign: false,
            isleftArrowEnabled: false,
            isrightArrowEnabled: true,
            isNewCampaign: false,
            campaignId: '',
            search: null,
            status: [],
            startDate: null,
            endDate: null,
            sellerId: '',
            rows: [
                10,
                25,
                50,
                100
            ],

            dateFilterType: 'Today',

            pageLimit: 10,
            campaigns: [],
            campaignData: {},
            adGroupsListData: [],
            createCampaignData: {},

            perPage: 10,
            pageCount: 0,
            pageNumber: 1,
            resultFrom: 1,
            resultTo: this.pageCount,
            isNextPageDisabled: false,
            isPrevPageDisabled: false,

            currentPage: 1,
            rowsPerPage: 10,
            options: [10, 20, 50, 100],

            sortedData: [],
            sortBy: null,
            sortedbyASC: true,
            sortClicked: false,
            showCustomDate: false,
            apiErrorMessage: null,
            targetingType: null,
            sellerIdRole: null,
            states: STATES,
            role: null,
            enableCreateCampaign: false,
            showCampaignTypeDialog: false,
        }
    },

    computed: {
        ...mapState(['currentTargetingType','campaignsApiData']),
        tooltipTitle() {
            return this.enableCreateCampaign ? '' : 'Contact Administrator';
        },
        filteredCampaigns() {
            if (this.filterChanged) {
                const start = (this.currentPage - 1) * this.rowsPerPage;
                const end = start + this.rowsPerPage;
                let campaigns = toRaw(this.campaigns)?.map(item => {
                    return {
                        ...item,
                        startDateTime: item?.start_time,
                        endDateTime: item?.expire_time
                    }
                });

                if (this.status?.length <= 0) {
                    return campaigns;
                }
                let statusLowerCase = new Array(this.status.length);
                for (var i = 0; i < this.status.length; i++) {
                    statusLowerCase[i] = this.status[i];
                }
                let filteredItems = campaigns?.filter((item) => {
                    let status;
                    if (item.state === 1) {
                        status = STATES.STATE1
                    } else if (item.state === 2) {
                        status = STATES.STATE2
                    } else if (item.state === 3) {
                        status = STATES.STATE3
                    } else if (item.state === 4) {
                        status = STATES.STATE4
                    } else if (item.state === 5) {
                        status = STATES.STATE5
                    } else if (item.state === 6) {
                        status = STATES.STATE6
                    } else if (item.state === 7) {
                        status = STATES.STATE7
                    } else if (item.state === 8) {
                        status = STATES.STATE8
                    } else if (item.state === 9) {
                        status = STATES.STATE9
                    }
                    return this.status?.includes(status)
                })
                // return filteredItems.slice(start, end)
                return filteredItems;
            } else {
                return this.campaigns;
            }
        },
        disablePastDate() {
            const today = new Date();
            const currentDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
            const minDate = currentDate > today ? today : currentDate;
            const year = minDate.getFullYear();
            const month = String(today.getMonth() + 1).padStart(2, '0');
            const day = String(today.getDate()).padStart(2, '0');
            return `${year}-${month}-${day}`;
        },
        disableFutureDate() {
            return moment().subtract(1, 'days').format('YYYY-MM-DD');
        },
        totalPages() {
            let newpages = 0;
            if (this.filterChanged) {
                newpages = Math.ceil(toRaw(this.filteredCampaigns)?.length / this.rowsPerPage)
            } else {
                newpages = Math.ceil(toRaw(this.campaigns)?.length / this.rowsPerPage)
            }

            if (this.currentPage !== 1 && this.currentPage > this.totalPages) {
                this.currentPage = this.totalPages;
            }
            newpages = Math.max(newpages, 1);
            return newpages;
        },
        campaignListApiData() {
            this.sortedData = this.campaignsApiData?.map(item => {
                return {
                    ...item,
                    startDateTime: item.start_time,
                    endDateTime: item.expire_time,
                    budget: item.budget
                }
            });
            return this.campaignsApiData;
        },
        resultQuery() {
            this.pageCount = toRaw(this.campaigns)?.slice((page.value - 1) * this.perPage, page.value * this.perPage)?.length;
            let campaigns = toRaw(this.campaigns)?.map(item => {
                return {
                    ...item,
                    startDateTime: item?.start_time,
                    endDateTime: item?.expire_time
                }
            });

            if (this.search) {
                let pageNumber = this.currentPage === 0 ? 1 : this.currentPage;
                const start = (pageNumber - 1) * this.rowsPerPage;
                const end = start + this.rowsPerPage;
                let filteredList = this.campaignListApiData?.filter((item) => {
                    return this.decodeString(item?.name).toLowerCase().includes(this.search?.toLowerCase())
                })
                this.campaigns = filteredList
                this.currentPage = filteredList?.length === 0 ? 0 : pageNumber;

                if (filteredList?.length < start && filteredList?.length > 0) {
                    this.currentPage = 1;
                    const newStart = (this.currentPage - 1) * this.rowsPerPage;
                    const newend = newStart + this.rowsPerPage;
                    this.sortedData = this.campaigns?.slice(start, end);
                    return this.campaigns?.slice(newStart, newend)
                }
                this.sortedData = this.campaigns?.slice(start, end);
                return this.campaigns?.slice(start, end)

            } else if (this.filterChanged && !this.sortClicked) {

                if (this.status?.length <= 0) {
                    return campaigns?.slice(start, end);
                }
                let statusLowerCase = new Array(this.status.length);
                for (var i = 0; i < this.status.length; i++) {
                    statusLowerCase[i] = this.status[i];
                }
                let filteredItems = campaigns?.filter((item) => {
                    let status;
                    if (item.state === 1) {
                        status = STATES.STATE1
                    } else if (item.state === 2) {
                        status = STATES.STATE2
                    } else if (item.state === 3) {
                        status = STATES.STATE3
                    } else if (item.state === 4) {
                        status = STATES.STATE4
                    } else if (item.state === 5) {
                        status = STATES.STATE5
                    } else if (item.state === 6) {
                        status = STATES.STATE6
                    } else if (item.state === 7) {
                        status = STATES.STATE7
                    } else if (item.state === 8) {
                        status = STATES.STATE8
                    } else if (item.state === 9) {
                        status = STATES.STATE9
                    }
                    return this.status.includes(status)
                })
                this.sortedData = filteredItems

            } else if (this.sortClicked || (this.filterChanged && this.sortClicked)) {
                this.sortClicked = false;
                let value = this.sortBy;
                if (this.sortedbyASC) {
                    if (this.sortBy === 'budget' || this.sortBy === 'spend') {
                        toRaw(this.sortedData)?.sort(function (a, b) {
                            var A = a[value];
                            var B = b[value];
                            return A - B;
                        })
                    } else if (this.sortBy === 'startDateTime' || this.sortBy === 'endDateTime') {
                        const distantFuture = new Date(8640000000000000)
                        toRaw(this.sortedData)?.sort(function (a, b) {
                            let dateA = new Date(a[value]) ;
                            let dateB = new Date(b[value]) ;
                            if(!a[value]) dateA = distantFuture;
                            if(!b[value]) dateB = distantFuture;
                            return dateA - dateB;
                        })
                    }
                    this.sortedbyASC = false;
                     //return toRaw(this.sortedData)?.slice((this.currentPage - 1) * this.perPage, this.currentPage * this.perPage)

                } else {
                    if (this.sortBy === 'budget' || this.sortBy === 'spend') {
                        toRaw(this.sortedData)?.sort(function (a, b) {
                            var A = a[value];
                            var B = b[value];
                            return B - A;
                        })
                        
                    } else if (this.sortBy === 'startDateTime' || this.sortBy === 'endDateTime') {
                        const distantFuture = new Date(8640000000000000)
                        toRaw(this.sortedData)?.sort(function (a, b) {
                            let dateA = new Date(a[value]) ;
                            let dateB = new Date(b[value]) ;
                            if(!a[value]) dateA = distantFuture;
                            if(!b[value]) dateB = distantFuture;
                            return dateB - dateA;
                        })
                    }
                    this.sortedbyASC = true;
                    //return toRaw(this.sortedData)?.slice((this.currentPage - 1) * this.perPage, this.currentPage * this.perPage)
                }
            }   
                if(!this.search) {
                    this.campaigns = this.campaignListApiData;
                    this.sortedData = this.campaigns;
                }
                let pageNumber = this.currentPage === 0 ? 1 : this.currentPage;
                const start = (pageNumber - 1) * this.rowsPerPage;
                const end = start + this.rowsPerPage;
                //this.campaigns = this.campaignListApiData;
                return this.sortedData?.slice(start, end); 
        }
    },

    beforeUnmount() {
        this.setCampaignApiData([])
        this.campaigns = [];
    },
    watch: {
        status(newVal, oldVal) {
            if (newVal !== oldVal) {
                console.log('onchange')
            }
        },
        startDate(newValue, oldValue) {
            this.startDate = newValue;
        },
        endDate(newVal, oldVal) {
            this.endDate = newVal;
        },
    },

    mounted() {
        this.targetingType = this.currentTargetingType  ?? '';
        this.sellerId = getLoggedSellerId();
        this.setCampaignClass('Sponsored');
        this.getCampaignList();
        this.editCampaignFlag = false;
        this.editCampaign = false;
        this.role = getCookie('role');
        /* localStorage.removeItem('adGroupList'); */
        this.resetAdGroupListData();
        checkAvailableCredit(this.sellerId)
            .then(res => res.json())
            .then(data => {
               if(typeof data === 'boolean') {
                    this.enableCreateCampaign = data;
                }
            })
    },
    methods: {
        ...mapActions(['setUser','setCampaignApiData','setAdGroupListData','setSellerId','resetAdGroupListData', 'setCampaignClass']),
        updateUser() {
            this.setUser('New User');
        },
        onCloseCampaignClass() {
            this.showCampaignTypeDialog = false;
        },
        onRowsPerPageChanged() {
            const oldRowsPerPage = this.rowsPerPage;
            this.rowsPerPage = Number(event.target.value);
            const oldTotalPages = this.totalPages;
            this.totalPages = Math.ceil(this.campaigns?.length / this.rowsPerPage);
            if (this.currentPage > this.totalPages) {
                this.currentPage = this.totalPages;
            }
            if (oldRowsPerPage !== this.rowsPerPage) {
                this.$nextTick(() => {
                    const newPage = Math.floor(((this.currentPage - 1) * oldRowsPerPage) / this.rowsPerPage) + 1;
                    this.currentPage = newPage;
                });
            }
        },
        decodeString(value) {
            return atob(value)
        },

        onDownloadTableClick() {
            let filterType;

            if (this.dateFilterType === 'Last 1 day') {
                filterType = 'LAST_1D'
                this.startDate = this.endDate = null;
            } else if (this.dateFilterType === 'Today') {
                filterType = 'TODAY'
                this.startDate = this.endDate = null;
            } else if (this.dateFilterType === 'Last 1 week') {
                filterType = 'LAST_7D'
                this.startDate = this.endDate = null;
            } else if (this.dateFilterType === 'Last 1 month') {
                filterType = 'LAST_30D'
                this.startDate = this.endDate = null;
            } else if (this.dateFilterType === 'Current month') {
                filterType = 'CURRENT_MONTH'
                this.startDate = this.endDate = null;
            } else {
                this.startDate = this.startDate ? this.startDate : null;
                this.endDate = this.endDate ? this.endDate : null;
            }

            let params = {
                'userId': this.sellerId,
                'fromDate': this.startDate ? encodeURIComponent(moment.utc((this.startDate)).format('YYYY-MM-DDTHH:mm:ss.SSSZ')) : null,
                'toDate': this.endDate ? encodeURIComponent(moment.utc((this.endDate)).format('YYYY-MM-DDTHH:mm:ss.SSSZ')) : null,
                'dateFilterType': filterType === 'TODAY' ? '' : this.startDate && this.endDate ? 'CUSTOM' : filterType ? filterType : ''
            };

            let str = '';
            for (const [key, value] of Object.entries(params)) {
                if (value)
                    str = str + key + "=" + value + "&";
            }

            str = str.slice(0, -1);

            if (toRaw(this.campaigns?.length > 0)) {
                downloadCampaignHomePageMetrics(str)
                // window.open(`http://34.117.156.208:80/jiomartads/v1/campaign/download?`+str);
                // window.open(`${API_URL}/jiomartads/v1/campaign/download?`+str);
            }
        },

        onSortClick(value) {
            this.sortClicked = true;
            this.sortBy = value;
        },

        nextPage() {
            this.showStatusFilter = false;
            this.currentPage++
        },
        prevPage() {
            this.showStatusFilter = false;
            this.currentPage--
        },

        onCreateCampaignClick() {
            if(this.role === "SUPERADMIN" || this.role === "OPS") {
                this.showCampaignTypeDialog = true;
            } else if (this.enableCreateCampaign) {
                this.editCampaignFlag = true;
                this.editCampaign = false;
            }
        },
        onContinueClick() {
            this.editCampaignFlag = true;
            this.editCampaign = false;
            this.showCampaignTypeDialog = false;
        },
        onStatusClick() {
            this.showStatusFilter = !this.showStatusFilter;
        },

        onDateRangeClick() {
            this.showDateRangeFilter = !this.showDateRangeFilter
        },

        onDateRangeApply(dateFilterType) {
            if (dateFilterType === 'CUSTOM') {
                this.showCustomDate = true;
                return
            }
            // if(!this.startDate && !this.endDate){
            //     this.showDateRangeFilter = false;
            //     return
            // }
            let startDate = this.startDate;
            let endDate = this.endDate;
            if (dateFilterType === 'LAST_1D') {
                this.dateFilterType = 'Last 1 day';
                this.startDate = this.endDate = null;
                startDate = endDate = null;
            } else if (dateFilterType === 'TODAY') {
                this.dateFilterType = 'Today';
                this.startDate = this.endDate = null;
                startDate = endDate = null;
            } else if (dateFilterType === 'LAST_7D') {
                this.dateFilterType = 'Last 1 week';
                this.startDate = this.endDate = null;
                startDate = endDate = null;
            } else if (dateFilterType === 'LAST_30D') {
                this.dateFilterType = 'Last 1 month';
                this.startDate = this.endDate = null;
                startDate = endDate = null;
            } else if (dateFilterType === 'CURRENT_MONTH') {
                this.dateFilterType = 'Current month';
                this.startDate = this.endDate = null;
                startDate = endDate = null;
            } else {
                this.dateFilterType = this.startDate + " - " + this.endDate;
                // this.dateFilterType = 'CUSTOM';
                startDate = this.startDate ? encodeURIComponent(moment.utc((this.startDate)).format('YYYY-MM-DDTHH:mm:ss.SSSZ')) : null;
                endDate = this.endDate ? encodeURIComponent(moment.utc((this.endDate)).add(1, 'days').format('YYYY-MM-DDTHH:mm:ss.SSSZ')) : null;
            }
            this.getCampaignList(startDate, endDate, dateFilterType);
            // this.startDate = this.endDate = null;
            this.showDateRangeFilter = false;
            // this.startDate = this.endDate = null;
        },

        onChange(event) {
            var data = event.target.value;
            this.filterChanged = true;
        },

        onClear() {
            this.filterChanged = false;
            this.status = [];
            this.showStatusFilter = false;
        },

        onCloseCampaignNavigation() {
            this.editCampaignFlag = false;
            this.campaignData = {};
            this.adGroupsListData = [];
            /* localStorage.removeItem('adGroupList'); */
            this.resetAdGroupListData();
            this.getCampaignList();
            this.search = null;
            this.dateFilterType = 'Today';
        },

        navigateToCampaignScreen(campaign, type) {
            if (type == "clone") {
                this.isNewCampaign = true;
            } else {
                this.editCampaign = true;
                this.isNewCampaign = false;
            }
            let id = campaign.id ? campaign.id : null;
            this.getCampaign(id, campaign.jmcampaign_id);
        },

        async onClick(campaign, action) {
            let state, status;

            if (action === 'pause') {
                state = 2, status = 0;
            } else if (action === 'play') {
                state = 1, status = 1;
            }

            if (campaign.id && campaign.jmcampaign_id) {
                await getCampaign(campaign.id, campaign.jmcampaign_id)
                    .then(res => res.json())
                    .then(data => {
                        let params = {
                            ...data,
                            state: state,
                            status: status,
                            channel_id: 4,
                        }
                        this.modifyCampaignAPI(params, 'submit')
                    })
            }
        },

        async modifyCampaignAPI(params, queryParams) {
            await modifyCampaign(params, queryParams)
                .then(res => res.json())
                .then(data => {
                    if (data?.errorMessageList?.length > 0) {
                        this.apiErrorMessage = data?.errorMessageList?.[0]
                    } else {
                        this.getCampaignList()
                    }
                })
                .catch(error => {
                    this.apiErrorMessage = error?.response?.data?.errorResponse?.message
                })
        },

        onDeleteCampaignClick(campaignId) {
            this.campaignId = campaignId;
            this.showConfirmationModal = true;
        },

        onDeleteModal() {
            this.deleteCampaign(this.campaignId);
            this.onCloseModal();
        },

        onCloseModal() {
            this.showConfirmationModal = false;
        },

        changePageValues(value) {
            this.limit = value;
        },

        formatStatus(value) {
            if (value === 1) {
                return STATES.STATE1;
            } else if (value === 2) {
                return STATES.STATE2;
            } else if (value === 3) {
                return STATES.STATE3;
            } else if (value === 4) {
                return STATES.STATE4;
            } else if (value === 5) {
                return STATES.STATE5;
            } else if (value === 6) {
                return STATES.STATE6;
            } else if (value === 7) {
                return STATES.STATE7;
            } else if (value === 8) {
                return STATES.STATE8;
            } else if (value === 9) {
                return STATES.STATE9;
            }
        },

        formatDate(value) {
            if (value) {
                return moment(String(value)).format('DD-MM-YYYY');
            }
        },

        formatDateToISO(value) {
            if (value) {
                let date = new Date(moment(String(value)).format('DD MMMM YYYY'));
                return date.toISOString();
            }
        },

        getAdgroupsData(adgroups) {
            let newAdgroups = [];
            adgroups?.map(tab => {
                delete tab.adGroupId;
                delete tab.updated;
                newAdgroups.push(tab);
            });
            return newAdgroups;
        },

        async onCloneCampaignClick(campaign) {
            let campaignData;

            if (campaign.id && campaign.jmcampaign_id) {
                await getCampaign(campaign.id, campaign.jmcampaign_id)
                    .then(res => res.json())
                    .then(data => {
                        campaignData = data
                    })
            }


            let name = campaignData.name;

            let params = {
                ...campaignData,
                budget_total_limit: campaignData?.budget_total_limit,
                budget_daily_limit: campaignData?.budget_daily_limit,
                budget_pacing: campaignData?.budget_pacing,
                name: btoa(atob(name) + ' copy'),
                channel_id: 4,
                objective: 13,
                campaign_type: [3],
                ad_format_type: this.targetingType === "Keyword" ? 1 : 2,
                isPDP: this.targetingType === "Product" ? true : false,
                deal_type: "Directdeals",
                app_site_id: APP_SITE_ID,
                adspots: this.targetingType === "Product" ? [ADSPOTS_PDP] : [ADSPOTS],
                sellerid: this.sellerId,
                new_revenue_type: 2,
                cpm: campaignData?.cpm,
                weight: 12,
                checksum: 870732149,
                id: null,
                jmcampaign_id: null
            }
            createCampaign(params, 'save')
                .then(res => res.json())
                .then(data => {
                    this.getCampaignList()
                })
                .catch(error => console.log(error, 'clone error'))
        },

        createCampaignRequest(newCampaign) {
            createCampaign(newCampaign)
                .then(res => res.json())
                .then(data => {
                    this.getCampaignList()
                })
            // create adgroup with jm campaign id
        },
        fetchCampaignsListApi() {
            let params = {
                'sellerId': this.sellerId,
            }
            this.fetchCampaignsListApiData(params)
        },

        async getCampaignList(startDate, endDate, dateFilterType) {

            let params = {
                'userId': this.sellerId,
                'fromDate': startDate,
                'toDate': endDate,
                'dateFilterType': startDate && endDate ? 'CUSTOM' : dateFilterType ? dateFilterType : ''
            };

            await getCampaignList(params)
                .then(response => {
                    if(response.status == 401) {
                        this.setSellerId('');
                        clearCookie('sellerId');
                    }
                    let headers = response.headers;
                    this.sellerIdRole = headers.get('User_id_role');
                    return response.json()
                })
                .then(data => {
                    if (data?.length > 0) {
                        this.campaigns = data?.map(item => {
                            return {
                                ...item,
                                startDateTime: item.start_time,
                                endDateTime: item.expire_time,
                                budget: item.budget,
                                spend: item.homePageMetrics?.length > 0 ? item.homePageMetrics[0]?.spend != null ? item.homePageMetrics[0].spend : 0 : 0
                            }
                        });
                        this.setCampaignApiData(this.campaigns)
                        this.sortedData = data?.map(item => {
                            return {
                                ...item,
                                startDateTime: item.start_time,
                                endDateTime: item.expire_time,
                                budget: item.budget
                            }
                        });
                    }
                })
        },

        getCampaign(campignId, jmId) {
            this.apiErrorMessage = null;
            this.loading = true;
            getCampaign(campignId, jmId)
                .then(res => res.json())
                .then(async data => {
                    if (data?.errorResponse?.message) {
                        this.apiErrorMessage = data?.errorResponse?.message
                        return
                    } else {
                        this.loading = false;
                        this.campaignData = data;
                        this.setCampaignClass(data.isPrivileged ? 'Privilege' : 'Sponsored');
                        if (data.id) {
                            await this.getAdgroupsList(data.id);
                        }
                        this.editCampaignFlag = true;
                    }
                })
        },

        //call adgroup list api with jm ids not actual ids

        async getAdgroupsList(campaign_id) {
            let params = {
                'channel_id': 4,
                'campaign_id': campaign_id
            }
            // this.fetchAdgroupListApiData(params);
            await getAdgroupsList(params)
                .then(res => res.json())
                .then(data => {
                    if (!data?.errorCode) {
                        const filteredData = data.filter(adGroup => adGroup.state !== 2);
                        filteredData?.map(async (adgroup) => {
                            await adgroupView(adgroup.id)
                                .then(res => res.json())
                                .then(data => {
                                    data.count = this.adGroupsListData?.length;
                                    data.adGroupName = data.name;
                                    data.isOpen = false;
                                    data.searchedProducts = data.products;
                                    this.adGroupsListData.push(data);
                                    this.setAdGroupListData(this.adGroupsListData);
                                })
                        })
                    } else {
                        let obj = {};
                        obj['adGroupName'] = '';
                        obj['products'] = [];
                        obj['keywords'] = [];
                        obj['count'] = 0;
                        obj['searchedProducts'] = [];
                        obj['isOpen'] = true;
                        this.adGroupsListData.push(obj);
                        this.setAdGroupListData(this.adGroupsListData);
                    }
                })
        },

        deleteCampaign(campaignId) {
            deleteCampaign(campaignId)
                .then(res => res.json())
                .then(data => {
                    if (data.campaignStatus == "DELETED") {
                        this.getCampaignList();
                    } else {
                    }
                })
                .catch(err => {
                    // this.$snackbar.global.showError('Error in getting Latest Status', err);
                })
        }

    }
}
</script>

<style scoped>
@font-face {
    font-family: "Inter-Regular";
    src: url('../assets/fonts/Inter-Regular.ttf');
}

table {
    table-layout: auto;
    width: 100%;
}

.container {
    background: #F8F8F8;
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
}

.middlecontainer {
    display: flex;
    flex-direction: row;
    width: 100%;
    height: 100%;
}

.emptyList {
    text-align: center;
    padding: 40px 0 30px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
}

.errorContainer {
    background: #FDEDED;
    border-radius: 8px;
    margin: 2%;
    margin-bottom: unset;
    padding: 18px 24px;
    font-family: 'Inter-Regular';
    font-style: normal;
}

.errorHeading {
    font-weight: 700;
    font-size: 14px;
    line-height: 140%;
    color: #EB5757;
    /* margin-bottom: 12px; */
    display: flex;
}


.apiErrorMessage {
    font-weight: 400;
    font-size: 12px;
    line-height: 140%;
    color: #666666;
    margin-top: 12px;
}

.emptyCaseTitle {
    font-weight: 400;
    font-size: 12px;
    line-height: 23px;
    text-align: center;
    color: #666666;
    margin-top: 30px;
}

.pageinationText {
    font-weight: 400;
    font-size: 14px;
    line-height: 21px;
    color: #9B9B9B;
}

.statusFilter {
    font-family: 'Inter-Regular';
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 150%;
    color: #41434C;
    padding: 14px 15px 30px 15px;
    width: 280px;
    box-shadow: 3px 4px 9px rgb(0 0 0 / 12%);
    border-radius: 4px;

    position: absolute;
    z-index: 1;
    background-color: #FFFFFF;
    top: 50px;
}

.dateRangeWrapper {
    position: relative;
}

.dateRangeContainer {
    min-width: 370px;
    position: absolute;
    top: 48px;
    z-index: 1;
    padding: 10px;
    border-radius: 4px;
    background: #FFFFFF;
    box-shadow: 3px 4px 9px rgba(0, 0, 0, 0.12);
}

.dateText {
    font-weight: 400;
    font-size: 12px;
    line-height: 23px;
    color: #41434C;
    opacity: 0.8;
    cursor: pointer;
    margin-bottom: 20px;
}

.dateText:last-child {
    margin-bottom: unset;
}

.applyClass {
    display: flex;
    margin-bottom: 10px;
}

.filters {
    display: flex;
}

.applyBtn {
    font-weight: 500;
    font-size: 14px;
    line-height: 23px;
    color: #0004B5;
    opacity: 0.8;
    padding: 8px;
    border: 1px solid #0004B5;
    border-radius: 4px;
    cursor: pointer;
}

.statusAction {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.clear {
    cursor: pointer;
    font-weight: 400;
    font-size: 12px;
    line-height: 17px;
    text-align: left;
    color: #2E31BE;
    display: inline-block;
    padding-right: 10px;
}

.close {
    cursor: pointer;
    font-weight: 400;
    font-size: 12px;
    line-height: 17px;
    text-align: right;
    color: #2E31BE;
    display: inline-block;
    padding-left: 10px;

}

.text {
    margin-top: 18px;
    margin-right: 70px;
    cursor: pointer;
}

.middlerightcontainer {
    display: flex;
    width: 100%;
    flex-direction: column;
}

.campaignsContainer {
    display: flex;
    max-width: 100%;
    flex-direction: column;
}

.campaigns {
    font-family: "Inter-Regular";
    margin: 1%;
    border-radius: 12px 12px 0px 0px;
    background: #FFFFFF;
    display: flex;
    flex-direction: column;
    /* max-width: 100%; */
    max-width: 1508px;
    overflow-x: scroll;
}

.menu {
    display: flex;
    padding: 25px 0 0 50px;
    border-bottom: 1px solid #E0E0E0;
}

.menuItem {
    margin-left: 76px;
    padding-bottom: 12px;
    cursor: pointer;
    font-weight: 400;
    font-size: 15px;
    line-height: 21px;

}

.menuItem:first-child {
    margin-left: unset;
}

.headerListitem {
    position: relative;
    background: #F5F5F5;
}

.list {
    display: flex;
    flex-direction: column;
    width: 100%;
}

.listItem {
    display: flex;
    width: 100%;
    align-items: center;
    border-bottom: 1px solid #E0E0E0;
}

.item {
    padding: 20px 10px;
    /* min-width: 135px; */
    font-weight: 400;
    font-size: 14px;
    line-height: 150%;
    color: #5C5C5C;
    text-align: center;
}

.name {
    text-decoration-line: underline;
    text-align: center;
    cursor: pointer;
    max-width: 100px;
    /* display: -webkit-box; */
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
}

.tooltip {
    visibility: hidden;
    background-color: rgba(black, 0.8);
    text-align: center;
    border-radius: 6px;
    padding: 5px 0;

    /* Position the tooltip */
    position: absolute;
    z-index: 1;
    top: -40px;
    left: 104px;
    visibility: hidden;
    padding: 5px;
}

.item.name:hover .tooltip {
    visibility: visible;
}

.nameHeader {
    text-decoration-line: none;
}

.type {
    font-size: 13px;
    font-weight: 500;
    min-width: 80px;
    text-align: center;
    display: flex;
    justify-content: center;
}

.dateFilter {
    border: 1px solid #E0E0E0;
    border-radius: 4px;
    padding: 8px 16px 8px 10px;
    color: #41434C;
    opacity: 0.8;
    margin-right: 12px;
    cursor: pointer;
}

.date {
    min-width: 106px;
    display: flex;
    justify-content: space-evenly;
}

.five {
    min-width: 78px;
    display: flex;
    justify-content: space-evenly;
}

.icons {
    min-width: 110px;
    display: flex;
    flex-direction: row;
    justify-content: center;
}

.statusWrapper {
    padding: 20px 10px;
    /* border-right: 1px solid #EEEEEE; */
    text-align: center;
    display: flex;
    justify-content: center;
}

.status {
    font-weight: 400;
    font-size: 12px;
    line-height: 160%;
    text-transform: uppercase;
    border-radius: 5px;
    min-width: 80px;
    display: flex;
    justify-content: space-evenly;
}

.saved {
    color: red;
    border: 1px solid red;
}

.scheduled {
    color: #5AA9CC;
    border: 1px solid #5AA9CC;
}

.pending {
    color: #E28834;
    border: 1px solid #E28834;
}

.active {
    color: #0A5F23;
    border: 1px solid #0A5F23;
}

.live {
    background: #0A5F23;
    color: #FFFFFF;
}

.pause {
    color: #BF0B0B;
    border: 1px solid #BF0B0B;
}

.header {
    padding: 20px 10px;
    font-weight: 600;
    font-size: 14px;
    line-height: 130%;
    color: #41434C;
    text-transform: unset;
    /* border-right: 1px solid #EEEEEE; */
    /* min-width: 135px; */
}

.actions {
    padding: 20px;
    display: flex;
    justify-content: center;
    align-content: center;
}

.createCampaign {
    display: flex;
    justify-content: space-between;
    margin: 40px 22px 40px 20px;
}

.lhs {
    display: flex;
}

.createBtn {
    font-weight: 700;
    font-size: 14px;
    line-height: 150%;
    text-align: center;
    color: #FFFFFF;
    background: #2E31BE;
    border-radius: 4px;
    padding: 10px 18px;
    max-width: 188px;
    cursor: pointer;
}

.disabledCreateBtn {
    opacity: 0.4;
    cursor: not-allowed;
}

.search {
    font-weight: 400;
    font-size: 12px;
    line-height: 26px;
    /* color: #9B9B9B; */
    display: flex;
    padding: 8px 20px 8px 10px;
    border: 1px solid #E4E5E6;
    border-radius: 4px;
    width: 234px;
    margin-right: 12px;
    cursor: pointer;
}

.searchImg {
    margin-right: 8px;
}

.dateRange {
    font-weight: 400;
    font-size: 12px;
    line-height: 23px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    max-width: 210px;
    padding: 9px 18px 9px 15px;
    color: rgba(#41434C, 0.8);
    border: 1px solid #E0E0E0;
    border-radius: 4px;
    margin-right: 12px;
    cursor: pointer;
}

.arrowIcon {
    width: 8px;
    height: 5px;
    margin-left: 48px;
}

.downloadIcon {
    margin-left: 18px;
}

.copyIcon {
    cursor: pointer;
    /* margin-right: 26px; */
}

.deleteIcon {
    cursor: pointer;
    display: flex;
}

.deleteIconDisabled {
    cursor: not-allowed;
    display: flex;
}

.paginate {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 16px 24px;
    gap: 715px;
    height: 66px;
    left: 274px;
    top: 775px;
    background: #FFFFFF;
    border: 1px solid #F8F8F8;
    width: -webkit-fill-available;
}

.rows {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.flexClass {
    display: flex;
}

.limit {
    display: flex;
    margin-left: 20px;
    font-weight: 500;
    font-size: 14px;
    line-height: 21px;
    color: #666666;
    border: 1px solid #EEEEEE;
    border-radius: 4px;
    padding: 10px 8px 10px 12px;
}

.leftArrow {
    display: flex;
    margin-left: 24px;
    cursor: pointer;
}

.leftArrowDisabled {
    display: flex;
    margin-left: 20px;
    opacity: 0.4;
    cursor: not-allowed;
}

.rightArrow {
    display: flex;
    margin-left: 20px;
    cursor: pointer;
}

.heading {
    display: flex;
    /* margin: 0; */
    justify-content: flex-start;
    font-family: 'Inter-Regular';
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 140%;
    color: #401D0C;
    padding: 27px 20px 22px;
    /* text-align: left; */
    margin-left: 0;
    background: #FFFFFF;
    /* width: 100%;*/
}

.headerRow {
    /* display: flex;
        justify-content: space-around; */
    padding: 22px 68px 22px 15px;
    background: #F7F7F7;
    border-radius: 4px;
    height: 60px;
}

.rowItem {
    /* display: flex;
        justify-content: space-around; */
    padding: 12px 20px 12px 20px;
}

.rowItem:nth-child(even) {
    background: #F6F6F6;
}</style>